import { useState, useEffect, useCallback } from 'preact/hooks';

/**
 *
 * @param productId
 * @param price
 * @param collectionsId
 * @returns {{discountPrice: {amount: number}, discountAmount: number, discountMessages: *[]}|null}
 */
const useDiscount = (productId, price, collectionsId) => {
  const [discount, setDiscount] = useState(null);

  const updateDiscount = useCallback(() => {
    setDiscount(window.getProductDiscount(productId, price, collectionsId));
  }, [productId, price]);

  useEffect(() => {
    document.addEventListener('product-discounts:updated', updateDiscount);
    return () => {
      document.removeEventListener('product-discounts:updated', updateDiscount);
    };
  }, [updateDiscount]);

  useEffect(() => {
    setDiscount(window.getProductDiscount(productId, price, collectionsId));
  }, [productId, price]);

  return discount;
};

export default useDiscount;
